import axios from "axios";

const BACKEND_URL = "https://reaimagination-app-production.up.railway.app";
const API = `${BACKEND_URL}/api`;

export const fundApi = {
  login: (email, password) =>
    axios.post(`${API}/auth/fund/login`, { email, password }),
};

export default fundApi;
